import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IGlobalPoprop, IServiceData } from "../../interfaces/global-interface";
import { ICliente, ClienteDefault  } from "../../interfaces/cliente-interface";
import { IVenta, IVentaProducto, VentaDefault } from "../../interfaces/venta-interface";
import { getServiceData } from "../../store/global-services";
import { IconButton, TextField, InputAdornment } from "@mui/material";
import { TabsGTS, TabPanelGTS} from "../../molecules/TabsGTS";
import ListClientGTS from "../../molecules/ListClientGTS";
import ListProductGTS from "../../molecules/ListProductGTS";
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import { UrlSiteBase } from '../../Global';
let { UrlBase } = UrlSiteBase();
const VentaRealizada = (globalProp?: IGlobalPoprop) => {
    const CliDefVenta = JSON.parse(JSON.stringify(ClienteDefault));
    CliDefVenta.nombres = 'Cliente de Mostrador';
    CliDefVenta.correo_electronico = 'N/A';
    CliDefVenta.telefono_uno = 'N/A';
    CliDefVenta.telefono_dos = 'N/A';
    const { idVenta } = useParams();
    const [tabSelected, setTabSelected] = useState<number>(0);
    const [venta, setVenta] = useState<IVenta>(VentaDefault);
    const [totalVenta, setTotalVenta] = useState<number>(0);
    const [clienteVenta, setClienteVenta] = useState<ICliente>(ClienteDefault);
    const [productosVenta, setProductosVenta] = useState<IVentaProducto[]>([]);
    const [productosAlmacenados, setProductosAlmacenados] = useState<IVentaProducto[]>([]);
    const formatObject = new Intl.NumberFormat('en-us', {minimumFractionDigits: 2});
    const navigate = useNavigate();
    const numFormat = (num: number) => {
        return formatObject.format(num)
    }
    const getSafeValue = (field: any) => {
        return field === undefined || field === null ? '' : field;
    };
    useEffect(() => {
        getServiceData({ nombre: 'venta', id: idVenta }).then(data => {
            if (data.success) {
                setVenta(data.venta);
                setTotalVenta(data.importeTotal);
                if (data.cliente.id === 0)
                    setClienteVenta(CliDefVenta);
                else
                    setClienteVenta(data.cliente);
                setProductosVenta(data.productosVenta);
                setProductosAlmacenados(data.productosAlmacenaje);
            }
        });
    }, []);
    return (<>
        <TabsGTS labels={ ['Resumen'] } tabSelected={tabSelected} >
            <TabPanelGTS index={0} value={tabSelected} className="tabpanel-resume">
                <h4 className="sub-title">Cliente</h4>
                <ListClientGTS key="list-client-resume" screen="venta" subScreen="resume" clientes={[clienteVenta]} />
                <h4 className="sub-title">Productos</h4>
                <ListProductGTS key="list-product-sales-resume" screen="venta" productos={productosVenta} />
                { productosAlmacenados.length == 0 ? <></> :
                    <>
                        <h4 className="sub-title">Almacenaje</h4>
                        <ListProductGTS  key="list-product-store-screen" screen="venta-almacenada-realizada" subScreen="resume" productos={productosAlmacenados} />
                    </>
                }
                <div className="panel-totals">
                    <p className="total"><span className="label">Importe Total:</span><span className="value">${numFormat(totalVenta)}</span> </p>
                </div>
                <div>
                <TextField id="observaciones" className="medium-textarea" multiline rows={2}
                    value={getSafeValue(venta?.observaciones)} label="Observaciones" color="secondary" />
                </div>
                <div className="panel-actions center">
                    <ButtonGST onClick={() => navigate(UrlBase + 'Ventas')}>Cancelar</ButtonGST>
                </div>
            </TabPanelGTS>
        </TabsGTS>
    </>);
}
export default VentaRealizada